import { render, staticRenderFns } from "./InHospitalInDetail.vue?vue&type=template&id=5314f87c&scoped=true"
import script from "./InHospitalInDetail.vue?vue&type=script&lang=js"
export * from "./InHospitalInDetail.vue?vue&type=script&lang=js"
import style0 from "./InHospitalInDetail.vue?vue&type=style&index=0&id=5314f87c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314f87c",
  null
  
)

export default component.exports